// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"aba86e87","450":"376bb422","558":"d85f8d07"}[chunkId] + ".chunk.css";
};